export default {
  title: 'Sugestie AI',
  subtitle: 'Sugestie od agenta FoodAmigos dla Twoich restauracji.',
  empty: 'Brak elementów do wyświetlenia.',
  tabs: {
    pending: 'Oczekujące',
    history: 'Historia',
  },
  table: {
    id: 'ID',
    company: 'Restauracja',
    type: 'Typ',
    summary: 'Sugestia',
    created_at: 'Utworzono',
    status: 'Status',
    actions: 'Akcje',
  },
  statuses: {
    pending: 'Oczekujące',
    confirmed: 'Potwierdzone',
    applied: 'Zastosowane',
    rejected: 'Odrzucone',
    failed: 'Błąd',
    expired: 'Wygasłe',
  },
  types: {
    'smart_pricing.global_reduce': 'Rabat na całe menu',
    'smart_pricing.category_reduce': 'Rabat na kategorię',
    'competitor_listing.confirm': 'Potwierdź ofertę marketplace',
    'catalog.price_correct': 'Korekta cen',
    'catalog.add_item': 'Dodaj brakującą pozycję',
    'catalog.quality': 'Jakość treści',
    'catalog.reorder': 'Reorganizacja menu',
  },
  actions: {
    review: 'Przegląd',
    confirm: 'Potwierdź',
    reject: 'Odrzuć',
    cancel: 'Anuluj',
    edit: 'Edytuj',
  },
  edit: {
    label: 'Opisz żądaną zmianę (zostanie wygenerowana nowa wersja)',
    placeholder: 'Opisz żądaną zmianę',
    placeholders: {
      'smart_pricing.global_reduce': 'np. ustaw 15%, zmień nazwę na „Summer -15%", lub zastosuj tylko dla dostawy',
      'smart_pricing.category_reduce': 'np. ustaw rabat na Napoje na 10% i wyłącz odbiór',
      'catalog.price_correct': 'np. usuń korektę „Cola" lub ustaw „Pizza" na €7,50',
      'catalog.add_item': 'np. usuń pozycję „Water" lub wycen „Falafel Wrap" na €6,50',
      'catalog.quality': 'np. usuń pozycje „Fries" i „Cola" z listy',
      'catalog.reorder': 'np. przesuń Napoje na koniec i przenieś bestseller na górę Bowls',
      'competitor_listing.confirm': 'np. zastąp link Uber Eats adresem https://…, lub dodaj Wolt: https://…',
    },
    submit: 'Generuj wersję',
  },
  revisions: {
    label: 'Wersja',
    original: 'Oryginał',
    revision_n: 'Wersja {{n}}',
  },
  detail: {
    title: 'Szczegóły sugestii',
    targets: 'Pozycje, których dotyczy',
    evidence: 'Dlaczego agent to sugeruje',
    no_targets: 'Brak szczegółów pozycji.',
    composed_from: 'Złożone z',
    items_suffix: 'pozycji',
    nutrition: 'Wartości odżywcze',
    uncategorized: 'Bez kategorii',
    decided_by: 'Zdecydowane przez',
    decision_note: 'Uwaga',
    category_existing: 'istniejąca',
    category_new: 'nowa',
    product: 'Produkt',
    price_change: 'Zmiana ceny',
    no_items: 'Brak pozycji',
    fills_image: '+ zdjęcie',
    fills_description: '+ opis',
    fills_nutrition: '+ wartości odżywcze',
    fills_modifiers: '+ modyfikatory',
    competitor_links: 'Linki konkurencji',
    no_competitor_links: 'Brak rozwiązanych linków konkurencji.',
  },
  competitors: {
    lieferando: 'Lieferando',
    wolt: 'Wolt',
    deliveroo: 'Deliveroo',
    uber_eats: 'Uber Eats',
  },
  reject_modal: {
    title: 'Odrzuć tę sugestię',
    note_label: 'Powód',
    note_placeholder: 'Krótko wyjaśnij, dlaczego odrzucasz tę sugestię',
  },
  toasts: {
    load_failed: 'Nie udało się załadować sugestii',
    confirmed: 'Sugestia potwierdzona',
    rejected: 'Sugestia odrzucona',
    action_failed: 'Nie udało się wykonać tej akcji',
    revision_created: 'Nowa wersja wygenerowana',
    revision_failed: 'Nie udało się wygenerować wersji z tej instrukcji',
    choose_revision: 'Ta sugestia ma wiele wersji — otwórz ją i wybierz jedną do potwierdzenia',
  },
};
